@if (!(loadingSubject | async)) {
  <div
    class="my-profile">
    @if (isOpenBadgesActive) {
      <app-open-badges-list [badges]="userOpenBadges"
        (badgeClick)="showOpenBadgeDialog($event)">
      </app-open-badges-list>
    }
    @if (userAchievements.length) {
      <section
        class="my-profile__achievements">
        <h2 class="my-profile__achievement-title">{{ 'my_profile.achievements_header' | translate }}</h2>
        <ul class="my-profile__achievement-list">
          @for (achievement of userAchievements; track achievement) {
            <li
              class="my-profile__achievement-card"
              [class.my-profile__achievement-card--locked]="!achievement.attributes.unLocked"
              [style.background-image]="achievement.attributes.unLocked ? 'url(' + achievement?.get('image') + ')' : null"
              [matTooltip]="achievement?.get('name')"
              (click)="openAchievementDialog(achievement.attributes)">
              @if (!achievement.attributes.unLocked) {
                <mat-icon
                  class="my-profile__locked-achievement-icon"
                  svgIcon="lock-rounded-fill">
                </mat-icon>
              }
            </li>
          }
        </ul>
      </section>
    }
  </div>
} @else {
  <div class="spinner-wrapper">
    <mat-spinner></mat-spinner>
  </div>
}

